<template lang="pug">
  .answers-feed
    .main__top
      .main__title.-to-prev-
        Icon.main__title-arrow(icon="arrow-prev")
        p Лента ответов

      .answers-feed__search.main-block
        .ajax__line.courses__ajax.courses__ajax_s(v-if="gettingFeedTaskList")
        SelectFeed(
          v-else
          v-model="selectedGroup"
          @input="getUserTask(selectedGroup)"
          :fields="feedTaskList"
          placeholder="Выберите раздел для проверки"
        )

      .answers-feed__content
        SkeletonCard(v-if="gettingFeedTask")
        .answer-feed__content-list(v-else)
          ul.answers-feed__list(v-if="getTaskBlock != undefined")
            li.answers-feed__item(
            v-for="task in getTaskBlock"
            :fields='task'
            :key="task.id"
            )
              CardFeed(
              :task="task"
              )
          .answers-feed__search.main-block(v-else-if="getCourse")
            | Не отвечено задание "{{getCourse.name}}"

</template>

<script>
import CardFeed from './components/Card';
import SkeletonCard from './components/Skeleton/SkeletonCard';
import SelectFeed from './components/Select/Select';
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    CardFeed,
    SelectFeed,
    SkeletonCard
  },
  data() {
    return {
      selectedGroup: ''
    };
  },
  computed: {
    ...mapState('answersValidatingFeed', {
      feedTaskList: s => s.data.feedTaskList,
      feedTask: s => s.data.feedTask,
      gettingFeedTask: s => s.meta.gettingFeedTask,
      gettingFeedTaskList: s => s.meta.gettingFeedTaskList,
      taskBlocks: s => s.data.taskBlocks
    }),
    getTaskBlock() {
      if (
        Object.keys(this.feedTask).length &&
        this.feedTask.taskBlocks.length > 0
      ) {
        return this.feedTask.taskBlocks;
      } else {
        return undefined;
      }
    },
    getCourse() {
      if (Object.keys(this.feedTask).length) {
        return this.feedTask.courses;
      } else {
        return undefined;
      }
    }
  },
  mounted() {
    this.getFeedTaskList();
  },
  methods: {
    ...mapActions('answersValidatingFeed', ['getFeedTaskList', 'getUserTask'])
  }
};
</script>
